"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtdToFastTagMapping = exports.getWarehouseScenarioKey = void 0;
const getWarehouseScenarioKey = ({ warehouseIds, maxServiceDays }) => {
    return warehouseIds.sort().join("-") + `-${maxServiceDays}`;
};
exports.getWarehouseScenarioKey = getWarehouseScenarioKey;
var OtdToFastTagMapping;
(function (OtdToFastTagMapping) {
    OtdToFastTagMapping["shopify"] = "Low";
    OtdToFastTagMapping["walmart"] = "High";
})(OtdToFastTagMapping = exports.OtdToFastTagMapping || (exports.OtdToFastTagMapping = {}));
//# sourceMappingURL=AvailabilityUtils.js.map